import '@babel/polyfill';
import jquery from 'vue-jquery';
import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-default/index.css';
import './styles/global.css';
import VueRouter from 'vue-router';
import store from './vuex/store';
import Vuex from 'vuex';
import routes from './routes';
import InputTag from 'vue-input-tag';
import Alert from './views/nav1/Alert';
import Hint from './views/nav1/Hint';
import CheckFilter from './views/nav1/CheckFilter.vue';
import Table from './views/nav1/Table.vue';
import axios from 'axios';
import {Circle2} from 'vue-loading-spinner';
import {ScaleOut} from 'vue-loading-spinner';
import 'semantic-ui-css/semantic.min.css';
import WaterMark from './views/nav1/waterMark.vue';
import JsonCSV from 'vue-json-csv';
import StarRating from 'vue-star-rating';
import Autocomplete from 'vuejs-auto-complete';
import Comment from './views/nav1/Comment';
import ElTableDraggable from 'element-ui-el-table-draggable';
//import Mock from './mock';
//Mock.bootstrap();

Vue.use(jquery);
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.component('input-tag', InputTag);
Vue.component('alert', Alert);
Vue.component('Hint', Hint);
Vue.component('Comment', Comment);
Vue.component('CheckFilter', CheckFilter);
Vue.component('Table', Table);
Vue.component('WaterMark', WaterMark);
Vue.component('circle2', Circle2);
Vue.component('ScaleOut', ScaleOut);
Vue.component('downloadCsv', JsonCSV);
Vue.component('StarRating', StarRating);
Vue.component('Autocomplete', Autocomplete);
Vue.component('ElTableDraggable', ElTableDraggable);

//NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  routes,
  //mode: 'history'
})

/*
router.beforeEach((to, from, next) => {
  //NProgress.start();
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
  }
  let user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})
*/

//router.afterEach(transition => {
//NProgress.done();
//});

var vm = new Vue({
  el: '#app',
  template: '<App/>',
  router,
  store: store,
  components: { App: App },
  render: h => h(App),
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js